import OCsvHeader from './index.vue';

OCsvHeader.install = app => {
  app.component(OCsvHeader.name, OCsvHeader);
};

export default OCsvHeader;
